import { Component } from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
//  templateUrl: './app2.component.html',
  styleUrls: ['./app.component.css']

})

export class AppComponent {


   constructor() {

   }




  }



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/app.component.ts